import { c as _c } from "react/compiler-runtime";
import { useCurrencies } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { classNames, Flex, Media, NumberDisplay, Separator, Skeleton } from "@opensea/ui-kit";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { calculateOrderTotals } from "../../lib/fees";
import { getFloorPriceDifference, OrdersSummary, OrdersSummaryItem, OrdersSummaryItemContent, OrdersSummaryItemDescription, OrdersSummaryItemSide, OrdersSummaryItemTitle, OrdersSummaryTokenValue, OrdersSummaryTokenValueSkeleton } from "../OrdersSummary";
import { CreateOrdersSummaryFragment } from "./CreateOrdersSummary.fragment";
import { CreatorEarningsToggle } from "./CreatorEarningsToggle";
import { CreatorEarningsTooltip } from "./CreatorEarningsTooltip";
export function CreateOrdersSummary(t0) {
  const $ = _c(71);
  const {
    symbol,
    adjustForFees,
    orders,
    currencyIdentifier,
    isReview,
    collection: collectionKey,
    orderSide,
    creatorFeeEnforced
  } = t0;
  const t = useTranslations("wallet.CreateOrdersSummary");
  const collection = readFragment(CreateOrdersSummaryFragment, collectionKey);
  const {
    getUsdPrice
  } = useCurrencies();
  const {
    withoutFees,
    afterFees,
    adjustedForFees,
    creatorFee,
    openseaFee
  } = calculateOrderTotals(orders);
  const totalValue = adjustForFees ? adjustedForFees : withoutFees;
  const totalValueUsd = getUsdPrice(currencyIdentifier, totalValue);
  const totalProceeds = adjustForFees ? withoutFees : afterFees;
  const creatorFeePercentage = creatorFee / withoutFees;
  const openseaFeePercentage = openseaFee / withoutFees;
  let t1;
  if ($[0] !== creatorFeeEnforced || $[1] !== orderSide || $[2] !== orders) {
    t1 = orders.some(_temp) && (creatorFeeEnforced || orderSide === "listing");
    $[0] = creatorFeeEnforced;
    $[1] = orderSide;
    $[2] = orders;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const displayCreatorFee = t1;
  const floorPriceUsd = collection?.floorPrice?.pricePerItem.usd;
  const floorPriceDifference = orders.length === 1 ? getFloorPriceDifference(floorPriceUsd, totalValueUsd, orders[0].quantity) : undefined;
  const {
    control
  } = useFormContext();
  let t2;
  if ($[4] !== control) {
    t2 = {
      control,
      name: "applyCreatorFee"
    };
    $[4] = control;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const applyCreatorFee = useWatch(t2);
  let t3;
  if ($[6] !== control || $[7] !== creatorFeeEnforced || $[8] !== isReview || $[9] !== orderSide) {
    t3 = orderSide === "listing" ? <Controller control={control} disabled={isReview} name="applyCreatorFee" render={t4 => {
      const {
        field
      } = t4;
      return <CreatorEarningsToggle checked={field.value} creatorFeeEnforced={creatorFeeEnforced} disabled={field.disabled} onCheckedChange={value => {
        field.onChange(value);
      }} />;
    }} /> : null;
    $[6] = control;
    $[7] = creatorFeeEnforced;
    $[8] = isReview;
    $[9] = orderSide;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const creatorFeeToggle = t3;
  const T0 = OrdersSummary;
  const T1 = OrdersSummaryItem;
  let t4;
  if ($[11] !== orderSide || $[12] !== t) {
    t4 = orderSide === "offer" ? t("totalOfferValue") : t("totalListingPrice");
    $[11] = orderSide;
    $[12] = t;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t4) {
    t5 = <OrdersSummaryItemContent><OrdersSummaryItemTitle>{t4}</OrdersSummaryItemTitle></OrdersSummaryItemContent>;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const T2 = OrdersSummaryItemSide;
  const T3 = OrdersSummaryTokenValue;
  const t6 = false;
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      Text: {
        weight: "semibold"
      }
    };
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const t8 = getUsdPrice(currencyIdentifier, totalValue);
  let t9;
  if ($[17] !== T3 || $[18] !== symbol || $[19] !== t7 || $[20] !== t8 || $[21] !== totalValue) {
    t9 = <T3 isFee={t6} overrides={t7} symbol={symbol} usdValue={t8} value={totalValue} />;
    $[17] = T3;
    $[18] = symbol;
    $[19] = t7;
    $[20] = t8;
    $[21] = totalValue;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== T2 || $[24] !== t9) {
    t10 = <T2>{t9}</T2>;
    $[23] = T2;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== T1 || $[27] !== t10 || $[28] !== t5) {
    t11 = <T1>{t5}{t10}</T1>;
    $[26] = T1;
    $[27] = t10;
    $[28] = t5;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Separator />;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== floorPriceDifference || $[32] !== orders.length || $[33] !== t) {
    t13 = orders.length === 1 && <OrdersSummaryItem><OrdersSummaryItemContent><OrdersSummaryItemDescription>{t("floorDifference")}</OrdersSummaryItemDescription></OrdersSummaryItemContent><OrdersSummaryItemSide><OrdersSummaryItemDescription className="font-mono">{floorPriceDifference ? <><NumberDisplay display="percent" value={floorPriceDifference} />{" "}{floorPriceDifference.gt(0) ? t("aboveFloor") : t("belowFloor")}</> : "\u2014"}</OrdersSummaryItemDescription></OrdersSummaryItemSide></OrdersSummaryItem>;
    $[31] = floorPriceDifference;
    $[32] = orders.length;
    $[33] = t;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== currencyIdentifier || $[36] !== getUsdPrice || $[37] !== openseaFee || $[38] !== openseaFeePercentage || $[39] !== orderSide || $[40] !== symbol || $[41] !== t) {
    t14 = orderSide === "listing" && <OrdersSummaryItem><OrdersSummaryItemContent><OrdersSummaryItemDescription>{t("platformFees")}{" "}{!Number.isNaN(openseaFeePercentage) && <>(<NumberDisplay display="percent" value={openseaFeePercentage} />)</>}</OrdersSummaryItemDescription></OrdersSummaryItemContent><OrdersSummaryItemSide><OrdersSummaryTokenValue isFee={true} symbol={symbol} usdValue={getUsdPrice(currencyIdentifier, openseaFee)} value={openseaFee} /></OrdersSummaryItemSide></OrdersSummaryItem>;
    $[35] = currencyIdentifier;
    $[36] = getUsdPrice;
    $[37] = openseaFee;
    $[38] = openseaFeePercentage;
    $[39] = orderSide;
    $[40] = symbol;
    $[41] = t;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== applyCreatorFee || $[44] !== creatorFee || $[45] !== creatorFeeEnforced || $[46] !== creatorFeePercentage || $[47] !== creatorFeeToggle || $[48] !== currencyIdentifier || $[49] !== displayCreatorFee || $[50] !== getUsdPrice || $[51] !== symbol || $[52] !== t) {
    t15 = displayCreatorFee && <OrdersSummaryItem><OrdersSummaryItemContent><Flex className="items-center gap-3"><Flex className="items-center gap-1.5"><OrdersSummaryItemDescription className="shrink-0">{t("creatorFees")}{" "}{!Number.isNaN(creatorFeePercentage) && <>(<NumberDisplay display="percent" value={creatorFeePercentage} />)</>}</OrdersSummaryItemDescription><CreatorEarningsTooltip creatorFeeEnforced={creatorFeeEnforced} /></Flex><Media greaterThanOrEqual="md">{creatorFeeToggle}</Media></Flex><Media lessThan="md">{creatorFeeToggle}</Media></OrdersSummaryItemContent><OrdersSummaryItemSide><OrdersSummaryTokenValue isFee={true} overrides={{
          Text: {
            className: classNames({
              "line-through": !applyCreatorFee && creatorFeeToggle
            })
          }
        }} symbol={symbol} usdValue={getUsdPrice(currencyIdentifier, creatorFee)} value={creatorFee} /></OrdersSummaryItemSide></OrdersSummaryItem>;
    $[43] = applyCreatorFee;
    $[44] = creatorFee;
    $[45] = creatorFeeEnforced;
    $[46] = creatorFeePercentage;
    $[47] = creatorFeeToggle;
    $[48] = currencyIdentifier;
    $[49] = displayCreatorFee;
    $[50] = getUsdPrice;
    $[51] = symbol;
    $[52] = t;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  let t16;
  if ($[54] !== orderSide) {
    t16 = orderSide === "listing" && <Separator />;
    $[54] = orderSide;
    $[55] = t16;
  } else {
    t16 = $[55];
  }
  let t17;
  if ($[56] !== currencyIdentifier || $[57] !== getUsdPrice || $[58] !== orderSide || $[59] !== symbol || $[60] !== t || $[61] !== totalProceeds) {
    t17 = orderSide === "listing" && <OrdersSummaryItem><OrdersSummaryItemContent><OrdersSummaryItemTitle>{t("totalEstProceeds")}</OrdersSummaryItemTitle></OrdersSummaryItemContent><OrdersSummaryItemSide><OrdersSummaryTokenValue symbol={symbol} usdValue={getUsdPrice(currencyIdentifier, totalProceeds)} value={totalProceeds} variant="result" /></OrdersSummaryItemSide></OrdersSummaryItem>;
    $[56] = currencyIdentifier;
    $[57] = getUsdPrice;
    $[58] = orderSide;
    $[59] = symbol;
    $[60] = t;
    $[61] = totalProceeds;
    $[62] = t17;
  } else {
    t17 = $[62];
  }
  let t18;
  if ($[63] !== T0 || $[64] !== t11 || $[65] !== t13 || $[66] !== t14 || $[67] !== t15 || $[68] !== t16 || $[69] !== t17) {
    t18 = <T0>{t11}{t12}{t13}{t14}{t15}{t16}{t17}</T0>;
    $[63] = T0;
    $[64] = t11;
    $[65] = t13;
    $[66] = t14;
    $[67] = t15;
    $[68] = t16;
    $[69] = t17;
    $[70] = t18;
  } else {
    t18 = $[70];
  }
  return t18;
}
function _temp(order) {
  return order.creatorFeeBasisPoints > 0;
}
export function CreateOrdersSummarySkeleton(t0) {
  const $ = _c(26);
  const {
    orderSide
  } = t0;
  const t = useTranslations("wallet.CreateOrdersSummary");
  let t1;
  if ($[0] !== orderSide || $[1] !== t) {
    t1 = orderSide === "offer" ? t("totalOfferValue") : t("totalListingPrice");
    $[0] = orderSide;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <OrdersSummaryItemContent><OrdersSummaryItemTitle>{t1}</OrdersSummaryItemTitle></OrdersSummaryItemContent>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <OrdersSummaryItemSide><OrdersSummaryTokenValueSkeleton /></OrdersSummaryItemSide>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <OrdersSummaryItem>{t2}{t3}</OrdersSummaryItem>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== orderSide) {
    t5 = orderSide === "listing" && <Separator />;
    $[8] = orderSide;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== orderSide) {
    t6 = orderSide === "listing" && <OrdersSummaryItem><OrdersSummaryItemContent><OrdersSummaryItemDescription><Skeleton className="h-3.5 w-[120px]" /></OrdersSummaryItemDescription></OrdersSummaryItemContent><OrdersSummaryItemSide><OrdersSummaryTokenValueSkeleton /></OrdersSummaryItemSide></OrdersSummaryItem>;
    $[10] = orderSide;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== orderSide) {
    t7 = orderSide === "listing" && <OrdersSummaryItem><OrdersSummaryItemContent><OrdersSummaryItemDescription><Skeleton className="h-3.5 w-[120px]" /></OrdersSummaryItemDescription></OrdersSummaryItemContent><OrdersSummaryItemSide><OrdersSummaryTokenValueSkeleton /></OrdersSummaryItemSide></OrdersSummaryItem>;
    $[12] = orderSide;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== orderSide) {
    t8 = orderSide === "listing" && <Separator />;
    $[14] = orderSide;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== orderSide || $[17] !== t) {
    t9 = orderSide === "listing" && <OrdersSummaryItem><OrdersSummaryItemContent><OrdersSummaryItemTitle>{t("totalEstProceeds")}</OrdersSummaryItemTitle></OrdersSummaryItemContent><OrdersSummaryItemSide><OrdersSummaryTokenValueSkeleton variant="result" /></OrdersSummaryItemSide></OrdersSummaryItem>;
    $[16] = orderSide;
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8 || $[24] !== t9) {
    t10 = <OrdersSummary>{t4}{t5}{t6}{t7}{t8}{t9}</OrdersSummary>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}